
import React, { useEffect, useLayoutEffect, useRef } from 'react'
import { useGLTF, useScroll } from '@react-three/drei'
import gsap from 'gsap'
import { useFrame } from '@react-three/fiber'

export function SpaceShip(props) {
  const { nodes, materials } = useGLTF('/models/ship/scene.gltf')

  const ref = useRef()
  const tl = useRef()
  const tl2 = useRef()

  const scroll = useScroll()

  let state = 'IDLE'

  useFrame(()=>{
    tl.current.seek((scroll.offset / 3) * (tl.current.duration()))
  })

  useEffect(()=>{
    if(props.call){
      console.log(props.call)
        // gsap.to(ref.current.rotation, {duration:0.5,x:props.call,ease: "linear",})
    }
  },[props.call])

  useLayoutEffect(()=>{
   
    tl.current = gsap.timeline({duration:6})

    // tl2.current = gsap.timeline({repeat:-1})
    // tl2.current.to(ref.current.rotation, {duration:10,y:6.4,ease: "linear",},0)

    // console.log(ref.current.rotation.y)


        tl.current.to(ref.current.rotation, {duration:1,y:0.8,ease: "linear",},0)
        tl.current.to(ref.current.position, {duration:1, y:50, z:0,ease: "linear",},0)
        tl.current.to(ref.current.scale, {duration:1, x:1.2, y:1.2, z:1.2,ease: "linear",},0)

        tl.current.to(ref.current.rotation, {duration:1,x:0, y:2, z:0, ease: "linear", onComplete:()=>{console.log("1")}}, 1)
        tl.current.to(ref.current.position, {duration:1, x:20, y:-60, z:-10,ease: "linear", onComplete:()=>{console.log("1")}},1)
        tl.current.to(ref.current.scale, {duration:1, x:1.5, y:1.5, z:1.5,ease: "linear", onComplete:()=>{console.log("1") }},1)


        // tl.current.to(ref.current.rotation, {duration:1,y:3.8,ease: "linear", onComplete:()=>{console.log("2")}}, 2)
        // tl.current.to(ref.current.position, {duration:1, y:200, x:0, z:0,ease: "linear", onComplete:()=>{console.log("2")}},2)
        // tl.current.to(ref.current.scale, {duration:1, x:3, y:3, z:3, ease: "linear", onComplete:()=>{console.log("2") }},2)

        // tl.current.to(ref.current.scale, {duration:1,x:0.1, y:0.1, z:0.1,ease: "linear"},5)

     

        // tl.current.to(ref.current.scale, {duration:1, x:0.5, y:0.5, z:0.5,ease: "linear", delay:9, onComplete:()=>{console.log("2") }},2)
     
        
        // tl.current.fromTo(".services-frame", { opacity: 0 }, { opacity: 1, duration: 1 }, 2);
    return () => {}

  },[])
  return (
    <group {...props} dispose={null} ref={ref}>
      <group position={[0, -10, 50]} rotation={[0, 0.5, 0]} scale={12}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_4.geometry}
          material={materials['Material.002']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_5.geometry}
          material={materials.Heatshield_Tiles}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_6.geometry}
          material={materials['Material.021']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_7.geometry}
          material={materials.Cryo_Section1}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_8.geometry}
          material={materials.Cryo_Section2}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_9.geometry}
          material={materials['Material.055']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_10.geometry}
          material={materials['Material.056']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_11.geometry}
          material={materials.Material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_12.geometry}
          material={materials['Material.053']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_13.geometry}
          material={materials['Material.087']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_14.geometry}
          material={materials['Material.004']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_15.geometry}
          material={materials['Material.023']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_16.geometry}
          material={materials.Serial_Number}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_17.geometry}
          material={materials.Logo}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_18.geometry}
          material={materials['Material.022']}
        />
        <group position={[0.046, -3.622, 1.081]} scale={[0.034, 0.047, 0.034]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_20.geometry}
            material={materials['Material.008']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_21.geometry}
            material={materials['Material.023']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_22.geometry}
            material={materials.Heatshield_Tiles}
          />
        </group>
        <group
          position={[0.046, -3.622, -1.081]}
          rotation={[-Math.PI, 0, -Math.PI]}
          scale={[-0.034, 0.047, 0.034]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_24.geometry}
            material={materials['Material.023']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_25.geometry}
            material={materials['Material.017']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_26.geometry}
            material={materials.Heatshield_Tiles}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_27.geometry}
            material={materials['Material.008']}
          />
        </group>
        <group
          position={[0.046, 3.886, 1.046]}
          rotation={[-0.224, 0, 0]}
          scale={[0.034, 0.047, 0.034]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_31.geometry}
            material={materials['Material.023']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_32.geometry}
            material={materials['Material.007']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_33.geometry}
            material={materials.Heatshield_Tiles}
          />
        </group>
        <group
          position={[0.046, 3.886, -1.047]}
          rotation={[-2.917, 0, -Math.PI]}
          scale={[-0.034, 0.047, 0.034]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_35.geometry}
            material={materials['Material.023']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_36.geometry}
            material={materials['Material.017']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_37.geometry}
            material={materials.Heatshield_Tiles}
          />
        </group>
        <group
          position={[0.187, -3.06, -0.001]}
          rotation={[-Math.PI, 1.49, -Math.PI]}
          scale={0.045}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_51.geometry}
            material={materials['Material.001']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_52.geometry}
            material={materials['Material.033']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_53.geometry}
            material={materials['Material.034']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_54.geometry}
            material={materials['Material.036']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_55.geometry}
            material={materials['Material.037']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_56.geometry}
            material={materials['Material.030']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_57.geometry}
            material={materials['Material.038']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_58.geometry}
            material={materials['Material.039']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_59.geometry}
            material={materials['Material.040']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_60.geometry}
            material={materials['Material.041']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_61.geometry}
            material={materials.Material}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_62.geometry}
            material={materials['Material.021']}
          />
        </group>
        <group
          position={[-0.126, -3.06, -0.188]}
          rotation={[-Math.PI, -1.032, -Math.PI]}
          scale={0.045}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_64.geometry}
            material={materials['Material.042']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_65.geometry}
            material={materials['Material.035']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_66.geometry}
            material={materials['Material.032']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_67.geometry}
            material={materials['Material.031']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_68.geometry}
            material={materials['Material.029']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_69.geometry}
            material={materials['Material.028']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_70.geometry}
            material={materials['Material.027']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_71.geometry}
            material={materials['Material.026']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_72.geometry}
            material={materials['Material.025']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_73.geometry}
            material={materials['Material.024']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_74.geometry}
            material={materials.Material}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_75.geometry}
            material={materials['Material.021']}
          />
        </group>
        <group
          position={[-0.116, -3.06, 0.181]}
          rotation={[0, -1.032, 0]}
          scale={[-0.045, 0.045, 0.045]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_77.geometry}
            material={materials['Material.052']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_78.geometry}
            material={materials['Material.051']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_79.geometry}
            material={materials['Material.050']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_80.geometry}
            material={materials['Material.049']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_81.geometry}
            material={materials['Material.048']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_82.geometry}
            material={materials['Material.047']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_83.geometry}
            material={materials['Material.046']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_84.geometry}
            material={materials['Material.045']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_85.geometry}
            material={materials['Material.044']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_86.geometry}
            material={materials['Material.043']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_87.geometry}
            material={materials.Material}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_88.geometry}
            material={materials['Material.021']}
          />
        </group>
        <group
          position={[0.371, -2.808, -0.6]}
          rotation={[-Math.PI, 1.234, -Math.PI]}
          scale={0.045}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_90.geometry}
            material={materials['Material.100']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_91.geometry}
            material={materials['Material.099']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_92.geometry}
            material={materials['Material.098']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_93.geometry}
            material={materials['Material.097']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_94.geometry}
            material={materials['Material.096']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_95.geometry}
            material={materials['Material.095']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_96.geometry}
            material={materials['Material.094']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_97.geometry}
            material={materials['Material.093']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_98.geometry}
            material={materials['Material.092']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_99.geometry}
            material={materials['Material.091']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_100.geometry}
            material={materials.Heat1}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_101.geometry}
            material={materials.Heat2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_102.geometry}
            material={materials.Material}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_103.geometry}
            material={materials['Material.021']}
          />
        </group>
        <group position={[0.371, -2.808, 0.609]} rotation={[0, 0.737, 0]} scale={0.045}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_105.geometry}
            material={materials['Material.100']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_106.geometry}
            material={materials['Material.099']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_107.geometry}
            material={materials['Material.098']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_108.geometry}
            material={materials['Material.097']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_109.geometry}
            material={materials['Material.096']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_110.geometry}
            material={materials['Material.095']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_111.geometry}
            material={materials['Material.094']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_112.geometry}
            material={materials['Material.093']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_113.geometry}
            material={materials['Material.092']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_114.geometry}
            material={materials['Material.091']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_115.geometry}
            material={materials.Heat1}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_116.geometry}
            material={materials.Heat2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_117.geometry}
            material={materials.Material}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_118.geometry}
            material={materials['Material.021']}
          />
        </group>
        <group
          position={[-0.686, -2.808, -0.002]}
          rotation={[Math.PI, -1.527, Math.PI]}
          scale={0.045}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_120.geometry}
            material={materials['Material.100']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_121.geometry}
            material={materials['Material.099']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_122.geometry}
            material={materials['Material.098']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_123.geometry}
            material={materials['Material.097']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_124.geometry}
            material={materials['Material.096']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_125.geometry}
            material={materials['Material.095']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_126.geometry}
            material={materials['Material.094']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_127.geometry}
            material={materials['Material.093']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_128.geometry}
            material={materials['Material.092']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_129.geometry}
            material={materials['Material.091']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_130.geometry}
            material={materials.Heat1}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_131.geometry}
            material={materials.Heat2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_132.geometry}
            material={materials.Material}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_133.geometry}
            material={materials['Material.021']}
          />
        </group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_29.geometry}
          material={materials['Material.022']}
          position={[0.856, 2.178, 0.042]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_39.geometry}
          material={materials['Material.021']}
          position={[0, -3.828, 0.925]}
          rotation={[3.138, 0, -1.57]}
          scale={[0.007, 0.038, 0.007]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_41.geometry}
          material={materials['Material.021']}
          position={[0.837, -3.828, 0.4]}
          rotation={[-3.125, -1.062, -1.555]}
          scale={[0.007, 0.038, 0.007]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_43.geometry}
          material={materials['Material.021']}
          position={[-0.828, -3.828, 0.4]}
          rotation={[-3.123, 1.062, 1.553]}
          scale={[-0.007, 0.038, 0.007]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_45.geometry}
          material={materials['Material.021']}
          position={[0.008, -3.828, -0.929]}
          rotation={[-0.005, 0, 1.572]}
          scale={[0.007, 0.038, 0.007]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_47.geometry}
          material={materials['Material.021']}
          position={[-0.828, -3.828, -0.404]}
          rotation={[0.011, 1.062, 1.562]}
          scale={[0.007, 0.038, 0.007]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_49.geometry}
          material={materials['Material.021']}
          position={[0.837, -3.828, -0.404]}
          rotation={[-0.031, -1.061, -1.599]}
          scale={[-0.007, 0.038, 0.007]}
        />
      </group>
      <group position={[0, -105, 50]} rotation={[0, 0.5, 0]} scale={12}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_135.geometry}
          material={materials['Material.002']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_136.geometry}
          material={materials['Material.021']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_137.geometry}
          material={materials['Material.053']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_138.geometry}
          material={materials['Material.086']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_139.geometry}
          material={materials.Cryo_Section3}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_140.geometry}
          material={materials.Cryo_Section4}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_141.geometry}
          material={materials['Material.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_142.geometry}
          material={materials.Heat_Tiles2}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_143.geometry}
          material={materials['Material.072']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_144.geometry}
          material={materials['Material.071']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_145.geometry}
          material={materials['Material.085']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_146.geometry}
          material={materials['Material.085']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_147.geometry}
          material={materials.Outer_Raptor}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_148.geometry}
          material={materials['Material.083']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_149.geometry}
          material={materials['Material.083']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_150.geometry}
          material={materials['Material.082']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_151.geometry}
          material={materials['Material.081']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_152.geometry}
          material={materials['Material.080']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_153.geometry}
          material={materials['Material.079']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_154.geometry}
          material={materials['Material.078']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_155.geometry}
          material={materials['Material.077']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_156.geometry}
          material={materials['Material.076']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_157.geometry}
          material={materials['Material.003']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_158.geometry}
          material={materials['Material.056']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_159.geometry}
          material={materials.Material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_160.geometry}
          material={materials['Material.023']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_161.geometry}
          material={materials['Material.022']}
        />
        <group position={[-0.481, 3.651, -0.825]} rotation={[-1.564, 0.004, 0.532]} scale={0.082}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_163.geometry}
            material={materials['Material.005']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_164.geometry}
            material={materials['Material.006']}
          />
        </group>
        <group
          position={[0.464, 3.651, -0.824]}
          rotation={[-1.564, -0.004, -0.534]}
          scale={[-0.082, 0.082, 0.082]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_166.geometry}
            material={materials['Material.005']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_167.geometry}
            material={materials['Material.006']}
          />
        </group>
        <group position={[0.463, 3.651, 0.826]} rotation={[-1.578, -0.004, -2.609]} scale={0.082}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_169.geometry}
            material={materials['Material.005']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_170.geometry}
            material={materials['Material.006']}
          />
        </group>
        <group
          position={[-0.482, 3.651, 0.826]}
          rotation={[-1.578, 0.004, 2.608]}
          scale={[-0.082, 0.082, 0.082]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_172.geometry}
            material={materials['Material.005']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_173.geometry}
            material={materials['Material.006']}
          />
        </group>
        <group position={[-0.081, -9.635, 0.168]} rotation={[0, -0.825, 0]} scale={0.045}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_175.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_176.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_177.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_178.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_179.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_180.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_181.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_182.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_183.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_184.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_185.geometry}
            material={materials.Material}
          />
        </group>
        <group
          position={[-0.092, -9.635, -0.166]}
          rotation={[-Math.PI, -0.824, -Math.PI]}
          scale={[-0.045, 0.045, 0.045]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_187.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_188.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_189.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_190.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_191.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_192.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_193.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_194.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_195.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_196.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_197.geometry}
            material={materials.Material}
          />
        </group>
        <group
          position={[0.206, -9.635, 0.006]}
          rotation={[0, 1.504, 0]}
          scale={[-0.045, 0.045, 0.045]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_199.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_200.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_201.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_202.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_203.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_204.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_205.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_206.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_207.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_208.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_209.geometry}
            material={materials.Material}
          />
        </group>
        <group
          position={[0.539, -9.635, 0.02]}
          rotation={[0, 1.504, 0]}
          scale={[-0.045, 0.045, 0.045]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_211.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_212.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_213.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_214.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_215.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_216.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_217.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_218.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_219.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_220.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_221.geometry}
            material={materials.Material}
          />
        </group>
        <group
          position={[0.432, -9.635, 0.32]}
          rotation={[0, 0.689, 0]}
          scale={[-0.045, 0.045, 0.045]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_223.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_224.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_225.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_226.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_227.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_228.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_229.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_230.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_231.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_232.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_233.geometry}
            material={materials.Material}
          />
        </group>
        <group
          position={[0.156, -9.635, 0.51]}
          rotation={[0, 0.049, 0]}
          scale={[-0.045, 0.045, 0.045]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_235.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_236.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_237.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_238.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_239.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_240.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_241.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_242.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_243.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_244.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_245.geometry}
            material={materials.Material}
          />
        </group>
        <group position={[-0.518, -9.635, -0.013]} rotation={[0, -1.506, 0]} scale={0.045}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_247.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_248.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_249.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_250.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_251.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_252.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_253.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_254.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_255.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_256.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_257.geometry}
            material={materials.Material}
          />
        </group>
        <group position={[-0.42, -9.635, 0.296]} rotation={[0, -0.691, 0]} scale={0.045}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_259.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_260.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_261.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_262.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_263.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_264.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_265.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_266.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_267.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_268.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_269.geometry}
            material={materials.Material}
          />
        </group>
        <group position={[-0.169, -9.635, 0.496]} rotation={[0, -0.05, 0]} scale={0.045}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_271.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_272.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_273.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_274.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_275.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_276.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_277.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_278.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_279.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_280.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_281.geometry}
            material={materials.Material}
          />
        </group>
        <group
          position={[0.443, -9.635, -0.302]}
          rotation={[-Math.PI, 0.691, -Math.PI]}
          scale={0.045}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_283.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_284.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_285.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_286.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_287.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_288.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_289.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_290.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_291.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_292.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_293.geometry}
            material={materials.Material}
          />
        </group>
        <group
          position={[0.185, -9.635, -0.498]}
          rotation={[-Math.PI, 0.05, -Math.PI]}
          scale={0.045}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_295.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_296.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_297.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_298.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_299.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_300.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_301.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_302.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_303.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_304.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_305.geometry}
            material={materials.Material}
          />
        </group>
        <group
          position={[-0.412, -9.635, -0.315]}
          rotation={[-Math.PI, -0.689, -Math.PI]}
          scale={[-0.045, 0.045, 0.045]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_307.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_308.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_309.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_310.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_311.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_312.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_313.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_314.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_315.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_316.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_317.geometry}
            material={materials.Material}
          />
        </group>
        <group
          position={[-0.136, -9.635, -0.503]}
          rotation={[-Math.PI, -0.049, -Math.PI]}
          scale={[-0.045, 0.045, 0.045]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_319.geometry}
            material={materials['Material.020']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_320.geometry}
            material={materials['Material.019']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_321.geometry}
            material={materials['Material.018']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_322.geometry}
            material={materials['Material.016']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_323.geometry}
            material={materials['Material.015']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_324.geometry}
            material={materials['Material.014']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_325.geometry}
            material={materials['Material.013']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_326.geometry}
            material={materials['Material.012']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_327.geometry}
            material={materials['Material.011']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_328.geometry}
            material={materials['Material.010']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_329.geometry}
            material={materials.Material}
          />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/models/ship/scene.gltf')